<mat-card>{{'pyticOrderCards' | translate}}</mat-card>

<div class="container" style="padding: 25px;">

    <mat-grid-list cols="7" rowHeight="50px">
        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" (click)="onApply()" matDateRangePickerApply>{{'filter'
                            |
                            translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            &nbsp;
            &nbsp;
            <mat-form-field>
                <mat-label>{{'orderNo' | translate}}</mat-label>
                <input matInput [(ngModel)]="searchByOrderId">
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">

            <button mat-raised-button color="primary" (click)="onApply()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
            <button mat-raised-button color="primary" [disabled]="reports.length == 0" style="margin-left: 10px;"
                (click)="Print()">
                <mat-icon>print</mat-icon>
                {{'print' | translate}}
            </button>
            <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="exportAsXLSX()">
                <mat-icon>import_export</mat-icon>
                {{'exportExcel' | translate}}
            </button>

        </mat-grid-tile>


    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort id="ordersTable">

            <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.orderId}} </td>
                <!-- <td mat-footer-cell *matFooterCellDef></td> -->
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.date | date: 'dd/MM/yyyy hh:mm'}} </td>
                <!-- <td mat-footer-cell *matFooterCellDef></td> -->
            </ng-container>

            <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
                <!-- <td mat-footer-cell *matFooterCellDef></td> -->
            </ng-container>

            <ng-container matColumnDef="productName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.productName}} </td>
                <!-- <td mat-footer-cell *matFooterCellDef></td> -->
            </ng-container>

            <ng-container matColumnDef="CardCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.cardCode}} </td>
                <!-- <td mat-footer-cell *matFooterCellDef></td> -->
            </ng-container>

            <ng-container matColumnDef="CardRefNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'CardRefNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.cardRefNo}} </td>
                <!-- <td mat-footer-cell *matFooterCellDef></td> -->
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr> -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>